import type { AddressPeriod } from './AddressSearch';

export function datedPeriods(periods: AddressPeriod[], today = Date.now()) {
  return periods.filter(period => {
    if (!period.startDate) return false;
    const start = new Date(period.startDate).getTime();
    const end = period.endDate === null ? today : new Date(period.endDate).getTime();
    return Number.isFinite(start) && Number.isFinite(end) && start <= today && start < end;
  });
}

// Address intervals end when the next registered address starts. Apply all changes
// on the same date together and count organizations, rather than individual periods.
export function companyCountHistory(periods: AddressPeriod[], today = Date.now()) {
  const events = new Map<number, Map<string, number>>();
  const add = (date: number, org: string, delta: number) => {
    const changes = events.get(date) ?? new Map<string, number>();
    changes.set(org, (changes.get(org) ?? 0) + delta);
    events.set(date, changes);
  };
  datedPeriods(periods, today).forEach(period => {
    add(new Date(period.startDate!).getTime(), period.organizationNumber, 1);
    if (period.endDate && new Date(period.endDate).getTime() <= today) {
      add(new Date(period.endDate).getTime(), period.organizationNumber, -1);
    }
  });
  if (!events.size) return [];
  events.set(today, events.get(today) ?? new Map());
  const active = new Map<string, number>();
  return Array.from(events.entries()).sort(([a], [b]) => a - b).map(([date, changes]) => {
    changes.forEach((delta, org) => {
      const count = (active.get(org) ?? 0) + delta;
      if (count > 0) active.set(org, count); else active.delete(org);
    });
    return { date, count: active.size };
  });
}
